const visibleLines = 5

function expandTargetHidden(target: HTMLElement, trigger: HTMLElement, content: HTMLElement) {
  const styles = getComputedStyle(target)
  const visibleHeight = parseFloat(styles.lineHeight) * visibleLines
  if (content.clientHeight > visibleHeight) {
    target.style.height = `${visibleHeight.toString()}px`
    target.style.overflow = 'hidden'
    const rect = target.getBoundingClientRect()
    if (rect.top < 0) {
      content.scrollIntoView(true)
    }
    trigger.textContent = '▼詳細情報をもっと見る'
  } else {
    trigger.remove()
  }
}

function collapseTargetVisible(target: HTMLElement, trigger: HTMLElement) {
  target.style.height = ''
  target.style.overflow = ''
  trigger.textContent = '▲閉じる'
}

export function expandToggle() {
  const content = document.querySelectorAll<HTMLElement>('.js-expand-content')
  if (content.length === 0) return

  content.forEach((el) => {
    const target = el.querySelector<HTMLElement>('.js-expand-target')
    const trigger = el.querySelector<HTMLElement>('.js-expand-button')
    if (target === null || trigger === null) return

    expandTargetHidden(target, trigger, el)

    trigger.addEventListener('click', () => {
      if (target.style.height === '') {
        expandTargetHidden(target, trigger, el)
      } else {
        collapseTargetVisible(target, trigger)
      }
    })
  })
}
